import Vue from 'vue';
import {AxiosPromise} from 'axios';
import {DataTableRequest, DataTableResponse, Response, Warehouse} from '@/models';
// @ts-ignore
import FileSaver from 'file-saver';

class WarehouseService extends Vue {
  private ROOT_API = process.env.VUE_APP_ROOT_API + '/webapi/warehouse';

  public getAll(request: DataTableRequest): AxiosPromise<DataTableResponse<Warehouse>> {
    return Vue.axios.get<DataTableResponse<Warehouse>>(this.ROOT_API, {params: request});
  }

  public getAllByWarehouseCompany(request: DataTableRequest, warehouseCompanyId: string): AxiosPromise<DataTableResponse<Warehouse>> {
    return Vue.axios.get<DataTableResponse<Warehouse>>(this.ROOT_API + '/get-by-warehouse-company?id=' + warehouseCompanyId, {params: request});
  }

  public get(id: string): AxiosPromise<Response<Warehouse>> {
    return Vue.axios.get<Response<Warehouse>>(this.ROOT_API + '/' + id);
  }

  public getCurrentWarehouse(): AxiosPromise<Response<Warehouse>> {
    return Vue.axios.get<Response<Warehouse>>(this.ROOT_API + '/current');
  }

  public create(data: Warehouse): AxiosPromise<Response<Warehouse>> {
    return Vue.axios.post<Response<Warehouse>>(this.ROOT_API, data);
  }

  public update(data: Warehouse): AxiosPromise<Response<Warehouse>> {
    return Vue.axios.put<Response<Warehouse>>(this.ROOT_API + '/' + data.id, data);
  }

  public delete(id: string): AxiosPromise<Response<any>> {
    return Vue.axios.delete(this.ROOT_API + '/' + id);
  }

  public findByName(name?: string) {
    return Vue.axios.get(this.ROOT_API + '/find-by-name', {params: { name: name }});
  }

  public exportCsv(request: DataTableRequest) {
    return Vue.axios.get(this.ROOT_API + '/export', {responseType: 'blob', params: request})
      .then((response) => {
        if (response.headers['x-file-name']) {
          const fileName: string = decodeURI(response.headers['x-file-name']);
          FileSaver.saveAs(response.data, fileName);
        }
      });
  }

  public importCsv(file: File) {
    const formData = new FormData();
    formData.append('file', file);
    return Vue.axios.post(this.ROOT_API + '/import', formData, {headers: {'Content-Type': 'multipart/form-data'}});
  }
}

export const warehouseService = new WarehouseService();
